/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import DeleteModal from '~/components/DeleteModal';
import { addUserID } from '~/store/modules/User/actions';
import { Container } from './styles';

function UpdateUserCard({
  userData,
  handleUpdateUser,
  handleDelete,
  setForm,
  form,
  loading,
}) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Container>
      <h1>Atualizar dados do usuário: {userData.login}</h1>
      <Form onSubmit={handleUpdateUser} style={{ width: '100%' }}>
        <FormGroup>
          <Label>Usuário: </Label>
          <Input
            required
            defaultValue={userData.login}
            placeholder="Insira o usuário"
            type="text"
            onChange={(e) => setForm({ ...form, user: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>
            <span>(opcional)</span> Email:
          </Label>
          <Input
            required
            defaultValue={userData.email}
            placeholder="Insira o email"
            type="email"
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
        </FormGroup>
        {loading ? (
          <section>
            <Button color="primary" disabled className="btn2">
              <Spinner size="sm" color="light" />
            </Button>
            <Button color="danger" disabled className="btn1">
              Excluir
            </Button>
          </section>
        ) : (
          <section>
            <Button color="primary" onClick={handleUpdateUser} className="btn2">
              Atualizar
            </Button>
            <Button
              outline
              color="danger"
              onClick={() => {
                dispatch(addUserID(userData.id));
                toggle();
              }}
              className="btn1"
            >
              Excluir
            </Button>
          </section>
        )}
      </Form>
      <DeleteModal
        toggle={toggle}
        modal={modal}
        handleDelete={handleDelete}
        id={userData.id}
        loading={loading}
      />
    </Container>
  );
}

export default UpdateUserCard;
